export const AGENT_NAME_MIN_LENGTH = 5;
export const AGENT_NAME_MAX_LENGTH = 255;
export const AGENT_DESCRIPTION_MAX_LENGTH = 4000;
export const VERSION_NAME_MIN_LENGTH = 1;
export const VERSION_NAME_MAX_LENGTH = 255;
export const VERSION_DESCRIPTION_MAX_LENGTH = 4000;
